export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4015f100f2e7921ad038be38b00fcab998c4aba05b&name=revalidateCommunity!'